import React, { useEffect, useState } from "react";
import { AgCharts } from "ag-charts-react";
import DropdownFilter from "../Components/DropdownFilter";

function MonthlyAvgBalance({ data }) {
  const [filter, setFilter] = useState({
    name: "Overall",
    value: "overall_summary",
  });
  const [graphData, setGraphData] = useState([]);
  const [filteredData, setFilteredData] = useState({});
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }
  const mapData = (data) => {
    const res = data?.["x-axis"]?.map((item, index) => {
      return {
        quarter: item,
        deposit: data?.["y-axis"][index],
      };
    });
    return res;
  };
  const [options, setOptions] = useState({
    data: graphData,
    series: [
      {
        type: "bar",
        xKey: "quarter",
        yKey: "deposit",
        yName: "deposit",
        cornerRadius: 10,
        fill: "#0070d2",
      },
    ],
    axes: [
      {
        type: "category",
        position: "bottom",
        label: {
          fontSize: 9,
          fontWeight: "light",
        },
      },
      {
        type: "number",
        position: "left",
        label: {
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
          fontSize: 11,
          fontWeight: "light",
        },
      },
    ],
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 10, // Change the size of the color boxes
        },
      },
    },
    height: 300,
  });

  useEffect(() => {
    setFilteredData(data ? data[filter.value]?.monthly_average_balance : []);
    setGraphData(
      mapData(data ? data[filter.value]?.monthly_average_balance : [])
    );
  }, [filter, data]);

  useEffect(() => {
    setOptions({ ...options, data: graphData });
  }, [graphData]);

  return (
    <div className=" w-[49.5%] rounded-lg border border-[#e6ebed] h-[347px] py-4 overflow-x-auto overflow-y-hidden ">
      <div className=" px-4 w-full flex items-center justify-between">
        <p className=" text-base font-semibold">Monthly Avg Balance</p>
        <DropdownFilter filterValue={filter} setFilterValue={setFilter} />
      </div>
      <div className=" w-full h-full mt-1 ">
        {" "}
        <AgCharts options={options} />{" "}
      </div>
    </div>
  );
}

export default MonthlyAvgBalance;
